
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2qdw9_1bdf7_3",
  "root-no-actions": "awsui_root-no-actions_2qdw9_1bdf7_17",
  "root-variant-h1": "awsui_root-variant-h1_2qdw9_1bdf7_17",
  "root-variant-h1-refresh": "awsui_root-variant-h1-refresh_2qdw9_1bdf7_20",
  "root-variant-h2": "awsui_root-variant-h2_2qdw9_1bdf7_23",
  "root-has-description": "awsui_root-has-description_2qdw9_1bdf7_23",
  "root-variant-h2-refresh": "awsui_root-variant-h2-refresh_2qdw9_1bdf7_26",
  "root-variant-h3": "awsui_root-variant-h3_2qdw9_1bdf7_29",
  "root-variant-h3-refresh": "awsui_root-variant-h3-refresh_2qdw9_1bdf7_32",
  "root-no-wrap": "awsui_root-no-wrap_2qdw9_1bdf7_35",
  "main": "awsui_main_2qdw9_1bdf7_39",
  "main-variant-h1": "awsui_main-variant-h1_2qdw9_1bdf7_47",
  "main-variant-h1-refresh": "awsui_main-variant-h1-refresh_2qdw9_1bdf7_50",
  "main-variant-h2": "awsui_main-variant-h2_2qdw9_1bdf7_56",
  "main-variant-h3": "awsui_main-variant-h3_2qdw9_1bdf7_56",
  "main-variant-h2-refresh": "awsui_main-variant-h2-refresh_2qdw9_1bdf7_62",
  "actions": "awsui_actions_2qdw9_1bdf7_69",
  "actions-variant-h1": "awsui_actions-variant-h1_2qdw9_1bdf7_73",
  "actions-variant-h1-refresh": "awsui_actions-variant-h1-refresh_2qdw9_1bdf7_76",
  "actions-variant-h2": "awsui_actions-variant-h2_2qdw9_1bdf7_79",
  "actions-variant-h3": "awsui_actions-variant-h3_2qdw9_1bdf7_79",
  "actions-variant-h2-refresh": "awsui_actions-variant-h2-refresh_2qdw9_1bdf7_85",
  "actions-variant-h3-refresh": "awsui_actions-variant-h3-refresh_2qdw9_1bdf7_88",
  "title": "awsui_title_2qdw9_1bdf7_92",
  "title-variant-h2": "awsui_title-variant-h2_2qdw9_1bdf7_98",
  "title-variant-h3": "awsui_title-variant-h3_2qdw9_1bdf7_98",
  "title-variant-h2-refresh": "awsui_title-variant-h2-refresh_2qdw9_1bdf7_107",
  "info": "awsui_info_2qdw9_1bdf7_117",
  "description": "awsui_description_2qdw9_1bdf7_121",
  "description-variant-h1": "awsui_description-variant-h1_2qdw9_1bdf7_126",
  "description-variant-h1-refresh": "awsui_description-variant-h1-refresh_2qdw9_1bdf7_131",
  "description-variant-h2": "awsui_description-variant-h2_2qdw9_1bdf7_134",
  "description-variant-h3": "awsui_description-variant-h3_2qdw9_1bdf7_139",
  "description-variant-h3-refresh": "awsui_description-variant-h3-refresh_2qdw9_1bdf7_145",
  "heading": "awsui_heading_2qdw9_1bdf7_149",
  "heading-variant-h1": "awsui_heading-variant-h1_2qdw9_1bdf7_158",
  "heading-variant-h2": "awsui_heading-variant-h2_2qdw9_1bdf7_164",
  "heading-variant-h3": "awsui_heading-variant-h3_2qdw9_1bdf7_167",
  "heading-text": "awsui_heading-text_2qdw9_1bdf7_171",
  "counter": "awsui_counter_2qdw9_1bdf7_175"
};
  